
export const initialuserstate =  {
  isAdministrator:false,
  roleChecked:false
}


// WEBPACK FOOTER //
// ./src/redux/initialuserstate.js